/* Modern Standard Coffee — pairing pages (sections/msc-pairing.liquid). Draft 35/36, 19 Oct 2026.
   Keeps the summary/price in step with the chosen coffee and grind, then adds the two real lines
   (coffee bag with Grind property + partner product) and goes to the basket. Bag size comes from data-size. */
(function () {
  function init(root) {
    var OFFER = root.getAttribute('data-offer');
    var SIZE = root.getAttribute('data-size') || '200g';
    var P_ID = +root.getAttribute('data-partner-id');
    var P_FULL = +root.getAttribute('data-partner-full');
    var P_NOW = +root.getAttribute('data-partner-now');
    var CUR = root.getAttribute('data-currency') || 'GBP';
    var fmt = function (c) { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: CUR }).format(c / 100); };
    var q = function (s) { return root.querySelector(s); };
    var radios = Array.prototype.slice.call(root.querySelectorAll('input[name="pair-coffee"]'));
    if (radios.length && !radios.some(function (r) { return r.checked; })) radios[0].checked = true;
    function cur() { return radios.filter(function (r) { return r.checked; })[0] || null; }
    function grind() { var g = q('input[name="pair-grind"]:checked'); return g ? g.value : 'Whole bean'; }

    function update() {
      var c = cur(); if (!c) return;
      var cp = +c.getAttribute('data-price');
      var cNow = OFFER === 'coffee_free' ? 0 : cp;
      var full = cp + P_FULL, now = cNow + P_NOW, save = full - now;
      q('[data-pair-sum-coffee]').textContent = c.getAttribute('data-name') + ', ' + SIZE + ' · ' + grind().replace(/ \(.*\)/, '');
      q('[data-pair-sum-cprice]').innerHTML = OFFER === 'coffee_free' ? '<del>' + fmt(cp) + '</del><span class="msc-pair__free">Free</span>' : fmt(cp);
      q('[data-pair-sum-total]').textContent = fmt(now);
      q('[data-pair-total]').textContent = fmt(now);
      var was = q('[data-pair-was]'); if (was) was.innerHTML = save > 0 ? '<del>' + fmt(full) + '</del>' : '';
      var sv = q('[data-pair-save]'); if (sv) { sv.hidden = save <= 0; sv.textContent = 'You save ' + fmt(save); }
      var lbl = q('[data-pair-atc-label]'); if (lbl) lbl.textContent = 'Add both to basket · ' + fmt(now);
      var img = q('[data-pair-img]'); if (img) { img.src = c.getAttribute('data-img'); img.alt = c.getAttribute('data-name') + ' ' + SIZE + ' bag'; }
    }
    root.addEventListener('change', function (e) { if (e.target.name === 'pair-coffee' || e.target.name === 'pair-grind') update(); });
    update();

    var form = q('[data-pair-form]'), btn = q('[data-pair-atc]'), err = q('[data-pair-error]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var c = cur();
      if (!c) { err.textContent = 'Please choose a coffee.'; err.hidden = false; return; }
      err.hidden = true; btn.disabled = true;
      var items = [
        { id: +c.value, quantity: 1, properties: { 'Grind': grind() } },
        { id: P_ID, quantity: 1 }
      ];
      fetch((root.getAttribute('data-root') || '/').replace(/\/?$/, '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Something went wrong.');
          window.location.href = root.getAttribute('data-cart-url') || '/cart';
        })
        .catch(function (ex) { err.textContent = ex.message || 'Sorry, we could not add that to your basket. Please try again.'; err.hidden = false; btn.disabled = false; });
    });
  }
  function boot() { document.querySelectorAll('[data-pair]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();